import { createGlobalStyle } from 'styled-components';
import { lighten } from 'polished';

import GTStandardBold from './fonts/GT-Standard-L-Extended-Bold.otf';
import GTStandardMedium from './fonts/GT-Standard-L-Extended-Medium.otf';
import InterBold from './fonts/Inter-Bold.otf';
import InterRegular from './fonts/Inter-Regular.otf';
import InterSemiBold from './fonts/Inter-SemiBold.otf';

import { COLORS } from './styleguide';

/* eslint no-unused-expressions: 0 */
export const GlobalStyle = createGlobalStyle`
  .body_white {
    background-color: #fff;
  }

  .consents-form__text a {
    color: ${COLORS.indigo};
    text-decoration: none;

    &:hover,
    &:active {
      text-decoration: underline;
      color: ${lighten(0.1, COLORS.indigo)};
    }
  }

  @font-face {
    font-family: 'GT Standard';
    font-style: normal;
    font-weight: 500; /* Medium */
    font-display: swap;
    src: url('${GTStandardMedium}') format('opentype');
  }

  @font-face {
    font-family: 'GT Standard';
    font-style: normal;
    font-weight: 700; /* Bold */
    font-display: swap;
    src: url('${GTStandardBold}') format('opentype');
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400; /* Regular */
    font-display: swap;
    src: url('${InterRegular}') format('opentype');
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600; /* SemiBold */
    font-display: swap;
    src: url('${InterSemiBold}') format('opentype');
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700; /* Bold */
    font-display: swap;
    src: url('${InterBold}') format('opentype');
  }

  body {
    font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 16px;
    color: ${COLORS.midnightBlue};
    background-color: ${COLORS.aquaHaze};
  }

  #root {
    min-height: 100%;
  }
`;

export default GlobalStyle;
